import Question from './questions';
import AdditionQuestion from './additional-quest';
import ScaleAnswers from './scale-answers';


class FormQuestion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      questions: {},
      sendAm: sendAm,
      request: request,
      showAddField: false,
      lang: language, 
      descriptions: descriptions,
    }
  };

  back = e => {
    e.preventDefault();
    const { step } = this.state;
    this.setState({
      step: step - 1
    });
    //this.prevStep();
  };

  handleChange = (label, number, questionType) => (e) => {
    const value = e.target.value;
    let {questions} = this.state;
    let addField = false;
    questions[number] = { 
      value: value, 
      label: label, 
      questionType: questionType,
    };
    for (let key in questions) {
      if (questions[key].value < 9 && questions[key].questionType == 'radio'){
        addField = true;
      }
    }
    
    this.setState({
      showAddField: addField,
      questions: {
        ...this.state.questions,
        [number]: {
          value: value,
          label: label,  
          questionType: questionType,
        }
      }
    });
  };
  
  sendData(){
      const data = {
        request : this.state.request,
        sendAm : this.state.sendAm,
        questions: this.state.questions
      }
      let json = JSON.stringify(data);

      var request = $.ajax({
              context: this,
              type: "POST",
              url: prefix + 'process/process.php',
              data: json, // данные для отправки на сервер
              contentType: false,
              processData: false,
              cache: false,
          })
            .done(function( msg ) {
              this.setState({
                step: 3
              });
            })
            .fail(function( jqXHR, textStatus ) {
              this.setState({
                step: 4
              });
            });
  }

  handleSubmit = event => {
    event.preventDefault();
    const {showAddField, step} = this.state;
    
    if (showAddField){
      this.setState({
        step: 2,
      });
    }else{
      event.preventDefault();
      this.sendData();
    }
  }
  
  handleSubmitText = event => {
      event.preventDefault();
      this.sendData();
  }
  
  renderQuestion(question, key, questionType){
    return(
      <div className="form-group p-3 label-questions">
        <label className="control-label">{question}</label>
        <ScaleAnswers 
          questionName = {'question_name' + key}  
          questionValue = {'question_value' + key} 
          questionLabel = {question}
          handleChange = {this.handleChange}
          number = {key}
          questionType = {questionType}
        />
      </div>);
  }

  renderAdditionQuestion(question, key, questionType){
    return(
      <div className="form-group label-questions">
        <label className="control-label">{question}</label>
        <AdditionQuestion 
          questionName = {'question_name' + key}  
          questionValue = {'question_value' + key} 
          questionLabel = {question}
          handleChange = {this.handleChange}
          number = {key}
          questionType = {questionType}
        />
      </div>);
  }
   
  questionForm(type){
    let table = [];
    for (var prop in questions) {
      let label = questions[prop].label;
      let typeQuestion = questions[prop].type;
      
      if (typeQuestion == type && type == 'radio')
        table.push(this.renderQuestion(label, prop, typeQuestion))
      if (typeQuestion == type && type == 'text')
        table.push(this.renderAdditionQuestion(label, prop, typeQuestion))
    }
    return (
      table
    );
  }
  
  render() {
    const { step } = this.state;
    switch (step) {
      case 1:
        return (<div>
            <form key='1' onSubmit={this.handleSubmit}>
              {this.questionForm('radio')}
              <div className="remote p-3">
                {this.state.descriptions[this.state.lang].organization} 
                <a href="https://softline.ru/remote-work">{this.state.descriptions[this.state.lang].here}</a>
              </div>
              <div className="policy p-3">
                {this.state.descriptions[this.state.lang].agree}
                <a href="https://softline.ru/privacy-policy">{this.state.descriptions[this.state.lang].policy}</a>
                {this.state.descriptions[this.state.lang].give}
                <a href="https://softline.ru/security"> {this.state.descriptions[this.state.lang].pers}</a>
              </div>
              <div className="text-center submit">
                <button type="submit" className="btn btn-danger position-relative">{this.state.descriptions[this.state.lang].next}</button>
              </div>
            </form>
        </div>);
      case 2:
        return (<div>
            <form key='2' onSubmit={this.handleSubmitText}>
              {this.questionForm('text')}
              <div className="remote p-3">
                {this.state.descriptions[this.state.lang].organization} 
                <a href="https://softline.ru/remote-work">{this.state.descriptions[this.state.lang].here}</a>
              </div>
              <div className="text-center submit">
                <button type="button" className="btn btn-danger position-relative" onClick={this.back}>{this.state.descriptions[this.state.lang].back}</button>
                <button type="submit" className="btn btn-danger position-relative">{this.state.descriptions[this.state.lang].done}</button>
              </div>
            </form>
        </div>);
       case 3:
        return (<div>
            <h1 className="text-center h5 mt-3">
               {this.state.descriptions[this.state.lang].thanks} 
            </h1>
        </div>);
       case 4:
        return (<div>
            <h1 className="text-center h5 mt-3">
              {this.state.descriptions[this.state.lang].thanks}!
            </h1>
        </div>);
  }
};
}

export default FormQuestion;


// WEBPACK FOOTER //
// in/js/components/form-question.js